import React from 'react';
import { Text, TextVariant } from '@naf/text';
import { getMonthAndYear } from '../../../../utils/Dates';
import S from '../../Styles';
import { GreenCircle } from './EventList.styles';
import { MonthHeaderProps } from './EventList.types';

const MonthHeader = ({ month }: MonthHeaderProps) => (
  <S.IconHeader>
    <GreenCircle height={14} width={14} />
    <Text variant={TextVariant.Tag}>{getMonthAndYear(month)}</Text>
  </S.IconHeader>
);

export default MonthHeader;
